var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        printButton: "",
        downloadButton: "",
        close: _vm.closeModal,
        printStyle: _vm.printStyle,
        title: _vm.title,
      },
    },
    [
      _c("h3", { attrs: { slot: "modalHeader" }, slot: "modalHeader" }, [
        _c("i", { staticClass: "uk-icon-tags" }),
        _vm._v(" Лизинг"),
      ]),
      _vm._v(" "),
      _vm.auth
        ? _c(
            "div",
            { ref: "root", attrs: { slot: "modalBody" }, slot: "modalBody" },
            [
              _c("div", { ref: "leasingModalContent" }, [
                _vm.auth && _vm.list.length > 0
                  ? _c(
                      "ul",
                      { staticClass: "list" },
                      _vm._l(_vm.list, function (l, i) {
                        return _c("item", {
                          key: i,
                          attrs: { leasing: l, inModal: "" },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              !_vm.isIE
                ? [
                    _vm.isLoading
                      ? _c(
                          "div",
                          { staticClass: "loading-holder" },
                          [_c("loading", { attrs: { isWord: false } })],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "if-i-visible",
                          rawName: "v-if-i-visible",
                          value: {
                            callback: _vm.getMoreLeasings,
                            root: this.$refs.root,
                          },
                          expression:
                            "{ callback: getMoreLeasings, root: this.$refs.root }",
                        },
                      ],
                      staticClass: "target",
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.isIE && this.list.length < this.pagination.rows_count
                ? _c(
                    "div",
                    { staticClass: "btn-holder" },
                    [
                      _c(
                        "btn",
                        {
                          nativeOn: {
                            click: function ($event) {
                              return _vm.getMoreLeasings.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("span", [
                            _c("i", {
                              staticClass: "uk-icon-refresh",
                              class: { "uk-icon-spin": _vm.isLoading },
                            }),
                            _vm._v(" Загрузить ещё"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.auth
        ? _c("demo-message", {
            attrs: { slot: "modalBody" },
            slot: "modalBody",
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }